define('app/providers/sePlayPrv',[

  'app.env',
  'app/models/sePlayMdl',

  //'app/router/play_template'

], function (
  ENV,
  sePlayMdl

  //surveyRouter

) {

  var LOG_LABEL = 'PLAY PRV'

  var playSessionId = ENV.play_sid,
    gotoPage = location.search.match(/page_number=(\d+)/),
    gotoPageNr = gotoPage && gotoPage.length ? parseInt(gotoPage[1]) : 'NaN'

  var
    sePlayProvider = new sePlayMdl({
      id: playSessionId
    }, {
      gotoPageNr: gotoPageNr
    })

  return sePlayProvider

});
